
<template>
  <div class="row">
    <img :src="company.json.logo" :alt="company.json.name">
    <div class="text-center message" v-html="message"></div>
    <div class="text-center">
      <h5>Desenvolvido por <a href="http://www.adapcon.com.br" target="_blank" class="adapcon-primary">adapcon<strong class="adapcon-dot">.</strong></a></h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "proBlocked",
  data() {
    return {
      portal: this.$portal,
      company: this.$portal.company,
    };
  },
  mounted() {
    this.portal.isLoaded = true;
  },
  computed: {
    message() {
      return _.get(this.company, `json.message.blockedAccess['${this.company.domain}']`, '');
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  display: flex;
  min-height: 100vh;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 0px 50px 0 50px;

  .message {
    margin-top: 10px;
  }

  .adapcon-primary {
    color: #cc3a3a;
  }

  .developer {
    text-align: left !important;
  }

  .adapcon-dot {
    color: #808080 !important;
  }
}
</style>
